'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _errorCodes = require('../../utils/errorCodes');

var _errorCodes2 = _interopRequireDefault(_errorCodes);

var _logCategoryActionLabel = require('../../loggers/logCategoryActionLabel');

var _logCategoryActionLabel2 = _interopRequireDefault(_logCategoryActionLabel);

var _logging = require('../constants/logging');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (error, timeoutAction, statusAction, isInstreamLoggingEnabled) {
  if (!isInstreamLoggingEnabled) {
    return;
  }

  var msg = (0, _get2.default)(error, 'message', '');
  var code = (0, _get2.default)(error, 'code', '');
  var codeIndex = msg.indexOf('code');

  if (code === _errorCodes2.default.ECONNABORTED) {
    (0, _logCategoryActionLabel2.default)({ action: timeoutAction });
  } else if (codeIndex >= 0) {
    var statusCode = msg.substring(codeIndex + 5);
    (0, _logCategoryActionLabel2.default)({ action: statusAction + '.' + statusCode });
  } else {
    (0, _logCategoryActionLabel2.default)({ action: _logging.actions.instreamRequestTrackingDataError }, { message: msg });
  }
};
//# sourceMappingURL=handleInstreamError.js.map